import React from 'react'
import StripeCredentialsForm from '../components/StripeCredentialsForm'
import StripeBillingSettings from '../components/StripeBillingSettings'
import VercelConfigForm from '../components/VercelConfigForm'
import ManageMenus from '../components/ManageMenus'
import NavLayoutSettings from '../components/NavLayoutSettings'
import GeneralSettings from '../components/GeneralSettings'
import PushConfigSettings from '../components/PushConfigSettings'
import PushTemplateSettings from '../components/PushTemplateSettings'
import BroadcastManualForm from '../components/BroadcastManualForm'
import GlobalComponentsGallery from '../components/GlobalComponentsGallery'
import BrandingManager from '@/modules/branding/components/BrandingManager'
import TermsSettings from '../components/TermsSettings'
import ManageCryptoAssets from '@/modules/crypto-assets/components/ManageCryptoAssets'
import { SlackSettingsSection } from '@/modules/slack-integration'
import MaintenanceSettings from '../components/MaintenanceSettings'
import CandlesEngineSettings from '../components/CandlesEngineSettings'
import ThermometerManage from '../components/ThermometerManage'
import TrendConfigSettings from '../components/TrendConfigSettings'
import ManageOpportunitiesSettings from '../components/ManageOpportunitiesSettings'
import SignalsSettings from '../components/SignalsSettings'
import FiboTargetsSettings from '../components/FiboTargetsSettings'
import SignalsOverlayLevelsSettings from '../components/SignalsOverlayLevelsSettings'
import InOutSettings from '../components/InOutSettings'
import CommunitySettings from '../components/CommunitySettings'
import CommunityModeratorsSettings from '../components/CommunityModeratorsSettings'
import ResultsSettings from '../components/ResultsSettings'
import AnalysisSettings from '../components/AnalysisSettings'
import AnalysisEditorsSettings from '../components/AnalysisEditorsSettings'
import AnalysisCourtesySettings from '../components/AnalysisCourtesySettings'
import VisionSettings from '../components/VisionSettings'
import VisionModeratorsSettings from '../components/VisionModeratorsSettings'
import ChatSettings from '../components/ChatSettings'
import ChatModeratorsSettings from '../components/ChatModeratorsSettings'
import ModuleHeaderWarningSettings from '../components/ModuleHeaderWarningSettings'
import { RewardsSettingsSection } from '@/modules/rewards'

type SettingsTab =
  | 'general'
  | 'stripe'
  | 'vercel'
  | 'menus'
  | 'branding'
  | 'terms'
  | 'cryptos'
  | 'gallery'
  | 'slack'
  | 'maintenance'
  | 'candles'
  | 'thermometer'
  | 'push'
  | 'trends'
  | 'signals'
  | 'community'
  | 'inout'
  | 'analysis'
  | 'vision'
  | 'chat'
  | 'results'
  | 'rewards'

export default function SettingsPage() {
  const [tab, setTab] = React.useState<SettingsTab>('candles')

  return (
    <div className="mx-auto w-full max-w-[1850px]">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">ConfiguraÃ§Ãµes</h1>
        <p className="text-sm text-foreground/70">IntegraÃ§Ãµes e credenciais do sistema.</p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-[240px,1550px]">
        <nav className="rounded-md border border-border bg-muted/30 p-2">
          <button
            className={`flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'general' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('general')}
          >
            ConfiguraÃ§Ãµes gerais
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'stripe' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('stripe')}
          >
            Integrar Stripe
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'vercel' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('vercel')}
          >
            Integrar Vercel
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'menus' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('menus')}
          >
            Gerenciar menus
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'branding' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('branding')}
          >
            Branding / Logos
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'terms' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('terms')}
          >
            Termos de acordo
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'cryptos' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('cryptos')}
          >
            Gerenciar criptos
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'slack' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('slack')}
          >
            IntegraÃ§Ã£o Slack
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'maintenance' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('maintenance')}
          >
            ManutenÃ§Ã£o
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'candles' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('candles')}
          >
            Coleta de candles
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'trends' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('trends')}
          >
            Configurar tendÃªncias
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'thermometer' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('thermometer')}
          >
            Gerenciar termÃ´metro
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'signals' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('signals')}
          >
            Gerenciar sinais
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'community' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('community')}
          >
            Gerenciar comunidade
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'inout' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('inout')}
          >
            Gerenciar in-out
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'push' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('push')}
          >
            Configurar Push
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'analysis' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('analysis')}
          >
            Gerenciar AnÃ¡lises Cripto
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'vision' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('vision')}
          >
            Gerenciar Visoes
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'chat' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('chat')}
          >
            Gerenciar Chat
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'results' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('results')}
          >
            MÃ³dulo Resultados
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'rewards' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('rewards')}
          >
            MÃ³dulo Rewards
          </button>

          <button
            className={`mt-1 flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm ${
              tab === 'gallery' ? 'bg-background shadow' : ''
            }`}
            onClick={() => setTab('gallery')}
          >
            Componentes globais
          </button>
        </nav>

        <section>
          {tab === 'general' && <GeneralSettings />}

          {tab === 'stripe' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Stripe</h2>
              <p className="text-sm text-foreground/70">
                Defina suas credenciais do Stripe para habilitar a criaÃ§Ã£o de produtos/preÃ§os.
              </p>
              <StripeCredentialsForm />
              <StripeBillingSettings />
            </div>
          )}

          {tab === 'vercel' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Vercel</h2>
              <p className="text-sm text-foreground/70">Defina o Project ID e o Token para automaÃ§Ãµes.</p>
              <VercelConfigForm />
            </div>
          )}

          {tab === 'menus' && (
            <div className="space-y-6">
              <div className="space-y-3">
                <h2 className="text-lg font-medium">Menus por papel</h2>
                <p className="text-sm text-foreground/70">
                  Reordene, renomeie ou oculte os itens do menu de cada papel.
                </p>
                <ManageMenus />
              </div>
              <div className="space-y-3">
                <h2 className="text-lg font-medium">Layout de navegaÃ§Ã£o do membro</h2>
                <p className="text-sm text-foreground/70">
                  Controle se o menu do painel do membro aparece na lateral ou no topo (header da Home).
                </p>
                <NavLayoutSettings />
              </div>
            </div>
          )}

          {tab === 'branding' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Branding / Logos</h2>
              <p className="text-sm text-foreground/70">
                Gerencie os logos para menu lateral, cabeÃ§alho da Home e pÃ¡gina de Login (light e dark).
              </p>
              <BrandingManager />
            </div>
          )}

          {tab === 'terms' && <TermsSettings />}

          {tab === 'cryptos' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Gerenciar criptos</h2>
              <p className="text-sm text-foreground/70">
                Cadastre somente sÃ­mbolos disponÃ­veis na Bybit. Moedas cadastradas passam a ser monitoradas
                automaticamente pelo backend.
              </p>
              <ManageCryptoAssets />
            </div>
          )}

          {tab === 'slack' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">IntegraÃ§Ã£o Slack</h2>
              <p className="text-sm text-foreground/70">
                Conecte workspaces e selecione os canais para notificaÃ§Ã£o de oportunidades.
              </p>
              <SlackSettingsSection />
            </div>
          )}

          {tab === 'maintenance' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">ManutenÃ§Ã£o</h2>
              <p className="text-sm text-foreground/70">Ative ou desative o modo manutenÃ§Ã£o do site.</p>
              <MaintenanceSettings />
            </div>
          )}

          {tab === 'candles' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Coleta de candles</h2>
              <p className="text-sm text-foreground/70">
                Defina a engine e mercado padrÃ£o de coleta. PadrÃ£o: Perp USDT (linear).
              </p>
              <CandlesEngineSettings />
            </div>
          )}

          {tab === 'thermometer' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Gerenciar termÃ´metro</h2>
              <p className="text-sm text-foreground/70">
                Defina pesos 0-10 para cada confluÃªncia. Recurso disponÃ­vel apenas para usuÃ¡rio master.
              </p>
              <ThermometerManage />
            </div>
          )}

          {tab === 'push' && (
            <div className="space-y-6">
              <PushConfigSettings />
              <PushTemplateSettings />
              <BroadcastManualForm />
            </div>
          )}

          {tab === 'signals' && (
            <div className="space-y-6">
              <h2 className="text-lg font-medium">MÃ³dulo Sinais</h2>
              <p className="text-sm text-foreground/70">
                Controle quais roles e planos podem visualizar o mÃ³dulo de Sinais na pÃ¡gina de Oportunidades.
              </p>
              <SignalsSettings />
              <FiboTargetsSettings />
              <SignalsOverlayLevelsSettings />
            </div>
          )}

          {tab === 'community' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">MÃ³dulo Comunidade</h2>
              <p className="text-sm text-foreground/70">
                Controle quais roles e planos podem acessar o mÃ³dulo de Comunidade nos cards de oportunidades.
              </p>
              <CommunitySettings />
              <CommunityModeratorsSettings />
            </div>
          )}

          {tab === 'inout' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">MÃ³dulo in-out</h2>
              <p className="text-sm text-foreground/70">
                Configure os textos das notificaÃ§Ãµes enviadas para usuÃ¡rios que marcarem &quot;Estou dentro&quot; em uma
                oportunidade.
              </p>
              <InOutSettings />
            </div>
          )}

          {tab === 'analysis' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">MÃ³dulo AnÃ¡lises Cripto</h2>
              <p className="text-sm text-foreground/70">
                Controle quais roles e planos podem acessar o mÃ³dulo de AnÃ¡lises Cripto.
              </p>
              <AnalysisSettings />
              <AnalysisEditorsSettings />
              <AnalysisCourtesySettings />
              <ModuleHeaderWarningSettings module="analysis" label="Analises Cripto" />
            </div>
          )}

          {tab === 'vision' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Modulo Visoes</h2>
              <p className="text-sm text-foreground/70">
                Controle quais roles e planos podem acessar o modulo de Visoes.
              </p>
              <VisionSettings />
              <ModuleHeaderWarningSettings module="vision" label="Visoes" />
              <VisionModeratorsSettings />
            </div>
          )}

          {tab === 'chat' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Modulo Chat</h2>
              <p className="text-sm text-foreground/70">
                Controle quais roles e planos podem acessar o modulo de Chat.
              </p>
              <ChatSettings />
              <ModuleHeaderWarningSettings module="chat" label="Chat" />
              <ChatModeratorsSettings />
            </div>
          )}

          {tab === 'gallery' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">Componentes globais</h2>
              <p className="text-sm text-foreground/70">Exemplos de uso dos componentes compartilhados.</p>
              <GlobalComponentsGallery />
            </div>
          )}

          {tab === 'results' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">MÃ³dulo Resultados</h2>
              <p className="text-sm text-foreground/70">
                Controle quais roles e planos podem acessar o mÃ³dulo de Resultados nas oportunidades (ativas e encerradas).
              </p>
              <ResultsSettings />
            </div>
          )}

          {tab === 'rewards' && (
            <div className="space-y-3">
              <h2 className="text-lg font-medium">MÃ³dulo Rewards</h2>
              <p className="text-sm text-foreground/70">
                Configure UUIDs de afiliado por corretora, parÃ¢metros econÃ´micos, trial condicional e controle de acesso (role + plano).
              </p>
              <RewardsSettingsSection />
            </div>
          )}

          {tab === 'trends' && (
            <div className="space-y-6">
              <div className="space-y-3">
                <h2 className="text-lg font-medium">Gerenciar oportunidades</h2>
                <p className="text-sm text-foreground/70">
                  Controle a histerese e o retarget do RSI do timeframe menor.
                </p>
                <ManageOpportunitiesSettings />
              </div>
              <div className="space-y-3">
                <h2 className="text-lg font-medium">Configurar tendÃªncias</h2>
                <p className="text-sm text-foreground/70">
                  Defina as regras de confirmaÃ§Ã£o por pivÃ´ (Forma A) e por fechamento (Forma B).
                </p>
                <TrendConfigSettings />
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  )
}
